/**
 * @fileoverview Agent definition for the character-extractor-targeted-v2 primitive.
 *
 * This agent extracts specific character(s) by name from text,
 * using the same output format as the full character extractor.
 *
 * @category import.characters.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'character-extractor-targeted-v2',
  kind: 'primitive',
  name: 'Targeted Character Extractor',
  description: 'Extracts specific character(s) by name from chapter content.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-08',
    lastUpdated: '2025-01',
    taxonomyPath: 'import.characters.extraction',
    usedBy: ['CharacterPanel', 'use-character-extractor.ts'],
    relatedAgents: ['character-extractor-full-v2'],
  },
};
